"use client";

import Link from "next/link";
import { Mail, X, CheckCircle2 } from "lucide-react";
import { useState } from "react";

const Footer = () => {
  const [showCopied, setShowCopied] = useState(false);

  const copyEmail = (e: React.MouseEvent) => {
    e.preventDefault();
    navigator.clipboard.writeText("roger@lamicolabs.com");
    setShowCopied(true);
    setTimeout(() => setShowCopied(false), 2000);
  };
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">About Clairvoyo</h3>
            <p className="text-gray-600 pr-8">
              A{" "}
              <Link
                href="https://lamicolabs.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-classic-blue hover:underline"
              >
                Lamico Labs
              </Link>{" "}
              product helping businesses get clarity across their digital
              platforms.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Legal</h3>
            <div className="flex flex-col space-y-2">
              <Link
                href="/privacy"
                className="text-gray-600 hover:text-classic-blue w-fit"
              >
                Privacy Policy
              </Link>
              <Link
                href="/account/data-deletion"
                className="text-gray-600 hover:text-classic-blue w-fit"
              >
                Data Deletion
              </Link>
            </div>
          </div>

          {/* Connect */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Connect</h3>
            <div className="flex flex-col space-y-2">
              <Link
                href="https://x.com/lamicolabs"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-classic-blue flex items-center gap-2 w-fit"
              >
                <X className="w-4 h-4" />
                Follow on X
              </Link>
              <button
                onClick={copyEmail}
                className="text-gray-600 hover:text-classic-blue flex items-center gap-2 w-fit"
              >
                {showCopied ? (
                  <>
                    <CheckCircle2 className="w-4 h-4 text-green-500" />
                    <span className="text-green-500">Email Copied!</span>
                  </>
                ) : (
                  <>
                    <Mail className="w-4 h-4" />
                    <span>Email Us</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-gray-500 text-center">
            © {currentYear} Lamico Labs. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
